
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";



import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);

const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

  const[nauto,setnAuto]=useState("None");
  const[nauto1,setnAuto1]=useState("None");
  const[nauto2,setnAuto2]=useState("None");
  const[nauto3,setnAuto3]=useState("None");
  const[nauto4,setnAuto4]=useState("None");
  const[nauto5,setnAuto5]=useState("None");
  const[nauto6,setnAuto6]=useState("None");
const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x7736E2f8FCA111AD9A8Db32E333B8D4b5923d5c7";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0x3EA4766f721bd5503807D398071fA775736eE4F9";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Pay 60";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
          window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const auto7 = Number(alltasks[3]);
setAuto7(auto7);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[14])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[15])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[8])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[9])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[10])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[11])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[4])/1000000000000000000;
         setAuto6(auto6);
        

         const nauto = Number(alltasks[12])/1000000000000000000;
         setnAuto(nauto);
         const nauto1 = Number(alltasks[16]);
         setnAuto1(nauto1);
         const nauto2 = Number(alltasks[17]);
         setnAuto2(nauto2);
         const nauto3 = Number(alltasks[18]);
         setnAuto3(nauto3);
         const nauto4 = Number(alltasks[19]);
         setnAuto4(nauto4);
         const nauto5 = Number(alltasks[20]);
         setnAuto5(nauto5);
         

         
         
         
         
         
         const bonus = Number(alltasks[13]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[21])/1000000000000000000;
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[5]);
         document.querySelector("#pp").value  = Number(alltasks[5]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://crowdwhale.world/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    
    
    console.log(pack);
   
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>

    <section className="relative py-24 md:py-32">
  <div
    className="glow-orb glow-orb-slow w-[440px] h-[440px]"
    style={{
      left: "-160px",
      top: "-60px",
      background:
        "radial-gradient(circle, rgba(45, 212, 227, 0.35), transparent 70%)",
    }}
    
  />

  <div
    className="glow-orb w-[300px] h-[300px]"
    style={{
      right: "5%",
      bottom: "-80px",
      background:
        "radial-gradient(circle, rgba(45, 212, 227, 0.28), transparent 70%)",
    }}
  />

  <div className="max-w-[1480px] mx-auto px-6 md:px-10 relative z-10">
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 ">
      <div>
        <p className="text-cyan text-sm font-medium tracking-wide">
          Dashboard
        </p>

        <h2 className="font-display font-bold text-[30px] sm:text-[38px] md:text-[42px] leading-[1.1] mt-4 max-w-[520px]">
          Built For A
          <br />
          Connected Future
        </h2>
      </div>

      <p className="text-sm text-white/45 max-w-[360px] leading-relaxed">
        Every principle below reflects why individuals and communities choose to
        build with us, not just alongside us.
      </p>
    </div>

    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

       <div className="glow-border glass rounded-2xl p-6 card-glow  ">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
             🪙
            
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Upgrade
          </h3>
        </div>

      
          <div className="relative">
            <input
              type ="hidden"
               id ="test"
              placeholder="USDT"
              className="w-full bg-panel border border-white/10 rounded-lg px-3 py-2 text-xs text-white placeholder-white/30 focus:outline-none focus:border-cyan transition-colors"
            />
          </div>
              <Buy state={state} />
        </div>
  

        
      {/* Box 1 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
            🚀
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Re-Entry
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Single Leg Positions
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              {auto7} 
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              
            </span>
          </div>
        </div>
      </div>

      {/* Box 2 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow ">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #6bd6f0, #1c6fa8)",
            }}
          >
          🎯
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Packages
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              My Packages
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
               USDT {pack}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              
            </span>
          </div>
        </div>
      </div>

         {/* Box 1 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
          📈
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Income
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              My Direct Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              USDT {directs}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Single Leg Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              USDT {auto6}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
             Royalty
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
             USDT {bonus1}
            </span>
          </div>
            <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
             Level Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
             USDT {auto + auto1 + auto2 + auto3 + nauto}
            </span>
          </div>
            <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
             Total Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
             USDT {level}
            </span>
          </div>
        </div>
      </div>

      {/* Box 2 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow ">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #6bd6f0, #1c6fa8)",
            }}
          >
           💰
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Team
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
             My Direct Team 
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {direct}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Current Week Direct
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {bonus}
            </span>
          </div>
        </div>
      </div>
         {/* Box 1 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
            ⚡
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Level Income
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              level - I Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              USDT {auto}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              level - II Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              USDT {auto1}
            </span>
          </div>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - III Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
             USDT {auto2} 
            </span>
          </div>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - IV Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
               USDT {auto3}
            </span>
          </div>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              level - V Income
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2" }}>
              USDT {nauto}
            </span>
          </div>
          
        </div>
      </div>

      {/* Box 2 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow ">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #6bd6f0, #1c6fa8)",
            }}
          >
          🌟
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Level Team
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - I
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {nauto1}
            </span>
          </div>
           <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - II
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {nauto2}
            </span>
          </div>

 <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Leevel - III
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {nauto3}
            </span>
          </div>

 <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - IV
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {nauto4}
            </span>
          </div>


          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              Level - V
            </span>
            <span className="text-xs" style={{ color: "#6bd6f0" }}>
              {nauto5}
            </span>
          </div>
        </div>
      </div>

          <div className="glow-border glass rounded-2xl p-6 card-glow ">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
             🏆
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
           Referlink
          </h3>

        </div>

      
          <div style={{wordBreak:"break-all", fontSize:"0.8rem"}} className="relative">
            {referlink}&nbsp;&nbsp;<button
  onClick={() => navigator.clipboard.writeText(referlink)}
  style={{
    background: "#06b6d4",
    color: "#fff",
    padding: "6px 14px",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(6,182,212,0.3)"
  }}
>
  Copy
</button>
    

          </div>
          
        </div>
        
         {/* Box 1 */}
      <div className="glow-border glass rounded-2xl p-6 card-glow">
        <div className="flex items-center gap-3.5 mb-6">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shrink-0"
            style={{
              background:
                "radial-gradient(circle at 32% 28%, #7fe7f2, #0e8a99)",
            }}
          >
           ⛓️
          </div>

          <h3 className="font-display font-bold text-sm tracking-wide uppercase">
            Welcome To CrowdWhale :
          </h3>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col gap-4">
         

          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-semibold text-white/90">
              My Refer :
            </span>
            <span className="text-xs" style={{ color: "#7fe7f2",wordBreak:"break-all", fontSize:"0.8rem" }}>
              {refer}
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

                       
    </div>                      
  
  );
}

export default App;
